<template>
  <el-dialog :title="title" :visible="visible">
    <el-form label-width="60px" :model="editForm" :rules="rules" ref="editForm">
      <el-form-item label="名称" prop="name">
        <el-input
          size="small"
          v-model="editForm.name"
          auto-complete="off"
          placeholder="请输入名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="顺序" prop="index">
        <el-input
          size="small"
          v-model="editForm.index"
          auto-complete="off"
          placeholder="请输入工艺顺序"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="生产日期" prop="date">
        <el-date-picker v-model="editForm.date" type="date" placeholder="选择日期">
        </el-date-picker>
      </el-form-item> -->
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeDialog">取消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="loading"
        class="title"
        @click="submitForm"
        >保存</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      editForm: {},
      visible: true,
      loading: false,
      title: "修改流程",
      rules: {
        name: {
          required: true,
          message: "请输入流程名称",
          trigger: "blur",
        },
        index: {
          required: true,
          message: "请输入工艺顺序",
          trigger: "blur",
        },
      },
    };
  },
  props: ["rowData"],
  created() {
    if (this.rowData.name) {
      this.title = "修改流程";
     
    } else {
      this.title = "新增流程";
    }
     this.editForm = { ...this.rowData };
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
    submitForm() {
      this.$refs.editForm.validate((res) => {
        if (res) {
          this.$emit("save", this.editForm);
        }
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/processManage/pop/addProcess.vue